module.exports = __webpack_public_path__ + "img/cimb.9674dc1d.svg";